import Attachment from '~components/ui/attachment'
import { cn } from '~utils/cn'
import { FileThumbnailsProps } from './types'

const FileThumbnails = ({ images, onDelete, isVideo = false }: FileThumbnailsProps) => {
  if (!images?.length) {
    return null
  }

  return (
    <div className={cn('flex', images && images.length > 1 && 'flex-gap-x-2')}>
      {images?.map((source, index) => {
        return (
          <Attachment
            key={source}
            src={source}
            alt="thumbnail"
            onDelete={() => onDelete?.(index)}
            isVideo={isVideo}
          />
        )
      })}
    </div>
  )
}

export default FileThumbnails
